export default "__VITE_ASSET__BL8OCq8y__"